import CalendarOutlined from '@ant-design/icons/CalendarOutlined'
import DeleteOutlined from '@ant-design/icons/DeleteOutlined'
import EditOutlined from '@ant-design/icons/EditOutlined'
import FormOutlined from '@ant-design/icons/FormOutlined'
import MoreOutlined from '@ant-design/icons/MoreOutlined'
import ProfileOutlined from '@ant-design/icons/ProfileOutlined'
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined'
import SendOutlined from '@ant-design/icons/SendOutlined'
import SolutionOutlined from '@ant-design/icons/SolutionOutlined'
import { Dropdown, Form, Menu, message, Modal, Tag, Tooltip, Row, Col, Tabs, Button } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { useMediaQuery } from 'react-responsive'
import { blue } from '../../../color'
import AccessControlAction from '../../../components/AccessControlAction'
import {
  EmptyText,
  TitleContentBox,
  WordBreak,
} from '../../../components/Common/CellText'
import FileItem from '../../../components/Common/FileItemComponent/FileItem'
import LinkedTask from '../../../components/Common/Linked/LinkedTask'
import LinkedWork from '../../../components/Common/Linked/LinkedWork'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import PageTitle from '../../../components/PageTitle'
import PDFViewer from '../../../components/PDFViewer/PDFViewer'
import PopoverWatchTime from '../../../components/PopoverWatchTime'
import SpinnerInlineComponent from '../../../components/SpinnerInlineComponent/SpinnerInlineComponent'
import { systemName } from '../../../config'
import {
  ACL_ACTION_TYPE,
  DATE_TIME_FORMAT_DEFAULT,
  DOCUMENT_TYPE,
  VIEWLOG_DATE,
} from '../../../constants'
import DashboardLayout from '../../../layouts/DashboardLayout'
import {
  BlockLeft,
  BlockRight,
  DocumentContentWrapper,
  DocumentInfoList,
  HeadingButtonWrapper,
} from '../../../layouts/InternalDocumentDetailLayout/InternalDocumentDetailLayoutStyled'
import utils from '../../../utils'
import InternalDocumentComment from '../InternalDocumentComment'
import PopupPhanPhatDocument from '../PopupPhanPhatDocument'
import { UserListWrapper } from './InternalDocumentOutgoingDocDetailPageStyled'
import PopupHandleDocumentOutgoing from './PopupHandleDocumentOutgoing'

const { confirm } = Modal

const renderInfoText = string => {
  if (string) {
    if (string.length <= 20) return string
    return (
      <Tooltip title={string}>{string.substring(0, 20).concat('...')}</Tooltip>
    )
  }
}

const InternalDocumentOutgoingDocDetailPage = props => {
  const isTabletOrMobile = useMediaQuery({
    query: '(max-width: 1299px)',
  })

  const [form] = Form.useForm()

  const {
    match,
    commonStore,
    internalDocumentStore,
    loadingAnimationStore,
    history,
    connectedDocumentStore,
    selectPeopleStore,
    aclStore,
  } = props

  const { documentId } = match.params
  // Không xóa dòng khai báo aclActionsByUser (dù k dùng)
  const { aclActionsByUser } = aclStore

  const {
    selectedInternalDocumentOutgoing,
    followerAssignList = [],
  } = internalDocumentStore

  const [departWithUsers, setDepartWithUsers] = useState([])

  const getFollowerText = (userList = followerAssignList) => {
    if (!userList || userList.length === 0) return ''
    const names = userList
      .map(u => {
        let rawName = u.full_name || u.name || u.name_uppercase || u.assignee_name || ''
        if (!rawName && (u.id || u.username || u.assignee_code)) {
          const uId = u.id || u.username || u.assignee_code
          const userInfo = utils.getInfoUser(
            uId,
            departWithUsers.length > 0
              ? departWithUsers
              : selectPeopleStore.originDepartmentWithUserList
          )
          if (userInfo?.full_name) {
            rawName = userInfo.full_name
          } else {
            rawName = uId
          }
        }
        return utils.getNameInCapitalize(rawName) || rawName
      })
      .filter(Boolean)
    return names.join(', ')
  }

  const {
    title,
    document_number,
    date_issued,
    authority_issued_id,
    agency_issued,
    signer,
    outgoing_date,
    attachments,
    linkedTask,
    linkedWork,
    created_at,
    receive_address,
  } = selectedInternalDocumentOutgoing

  const [attachmentForView, setAttachmentForView] = useState()
  const [isLoadingComment, setIsLoadingComment] = useState(false)
  const [
    isVisiblePopupPhanPhatDocument,
    setIsVisiblePopupPhanPhatDocument,
  ] = useState(false)
  const [
    isVisiblePopupHandleDocument,
    setIsVisiblePopupHandleDocument,
  ] = useState(false)

  useEffect(() => {
    ;(async () => {
      try {
        await selectPeopleStore.getDepartmentWithUsers()
        const response = await selectPeopleStore.getDepartmentWithUsersV2()
        setDepartWithUsers(response.data)
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      }
    })()
  }, [])

  useEffect(() => {
    if (!attachments) return
    setAttachmentForView(
      attachments.find(file =>
        ['pdf', 'doc', 'docx'].includes(utils.getExtensionFile(file.name))
      )
    )
  }, [attachments])

  const renderAttachment = useMemo(
    () => (
      <PDFViewer
        fileId={attachmentForView?.id}
        customStyleObj={{ height: isTabletOrMobile ? 500 : 1000 }}
        fileType={utils.getExtensionFile(attachmentForView?.name)}
      />
    ),
    [attachmentForView]
  )

  const renderAuthorityIssuedList = (authorityIssuedId, agencyIssued) => {
    const authorityList = []
    if (authorityIssuedId) {
      authorityList.push(authorityIssuedId.name)
    }
    if (agencyIssued && agencyIssued !== authorityIssuedId?.name) {
      authorityList.push(agencyIssued)
    }
    if (authorityIssuedId || agencyIssued) {
      return authorityList.join(', ')
    }
    return <EmptyText>Không có cơ quan ban hành.</EmptyText>
  }

  const handleDeleteDocument = async () => {
    loadingAnimationStore.showSpinner(true)
    try {
      await internalDocumentStore.deleteOutgoingInternalDocumentById(documentId)
      history.push('/internal-document/outgoing-document')
      message.success('Xóa văn bản thành công!')
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const showConfirmDeleteDocument = () => {
    confirm({
      title: 'Bạn có muốn xóa văn bản này không?',
      icon: <QuestionCircleOutlined style={{ color: 'red' }} />,
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: 'danger',
      onOk() {
        handleDeleteDocument()
      },
    })
  }

  const handleReceiveDocumentToTruc = useCallback(() => {
    const serializableData = {
      id: selectedInternalDocumentOutgoing.id,
      title: selectedInternalDocumentOutgoing.title,
      document_number: selectedInternalDocumentOutgoing.document_number,
      date_issued: selectedInternalDocumentOutgoing.date_issued,
      signer: selectedInternalDocumentOutgoing.signer,
      attachments: selectedInternalDocumentOutgoing.attachments.map(
        attachment => ({
          id: attachment.id,
          name: attachment.name,
        })
      ),
    }

    const state = {
      data: serializableData,
      extendData: {
        fileRelease: serializableData.attachments[0] || null,
        response: serializableData.attachments.slice(1),
        organizations: [],
      },
    }

    history.push({
      pathname: '/connected-document/outgoing-document/create',
      state: state,
    })
  }, [selectedInternalDocumentOutgoing, history])

  const handleReceiveDocumentToUBQLV = () => {
    connectedDocumentStore.setDataReceiveDocument(
      selectedInternalDocumentOutgoing
    )
    history.push('/connected-committee-document/outgoing-document/create')
  }

  const menuHandleDocument = (
    <Menu style={{ borderRadius: 12, padding: '8px 0', minWidth: 220 }}>
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.lienthong_vimc__OUTGOING
      ) && (
        <Menu.Item
          onClick={handleReceiveDocumentToTruc}
          icon={<SendOutlined style={{ color: blue }} />}>
          <span style={{ color: blue }}>Đi liên thông văn bản VIMC</span>
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.lienthong_ubqlv__OUTGOING
      ) && (
        <Menu.Item
          onClick={handleReceiveDocumentToUBQLV}
          icon={<SendOutlined style={{ color: blue }} />}>
          <span style={{ color: blue }}>Đi liên thông văn bản UBQLV</span>
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.tao_nv_tu_vb__OUTGOING
      ) && (
        <Menu.Item
          onClick={() =>
            history.push(
              `/mission/create?document_code=${documentId}&title=${title}&type=OUTGOING`
            )
          }
          icon={<ProfileOutlined style={{ color: blue }} />}>
          <span style={{ color: blue }}>Tạo nhiệm vụ từ văn bản</span>
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.tao_cv_tu_vb__OUTGOING
      ) && (
        <Menu.Item
          onClick={() => {
            const documentList = attachments.map(el => el.id + '/' + el.name)
            const queryStringParams = queryString.stringify(
              {
                document_list: documentList,
                document_title: title,
                document_code: documentId,
                document_type: DOCUMENT_TYPE.OUTGOING,
              },
              { arrayFormat: 'index' }
            )
            history.push(`/works/create?${queryStringParams}`)
          }}
          icon={<SolutionOutlined style={{ color: blue }} />}>
          <span style={{ color: blue }}>Tạo công việc từ văn bản</span>
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.delete__OUTGOING) && (
        <Menu.Item
          danger
          onClick={showConfirmDeleteDocument}
          icon={<DeleteOutlined />}>
          Xóa văn bản
        </Menu.Item>
      )}
    </Menu>
  )

  useEffect(() => {
    ;(async () => {
      try {
        loadingAnimationStore.showSpinner(true)
        await internalDocumentStore.getInternalDocumentOutgoingById(documentId)
      } catch (err) {
        history.push('/internal-document/outgoing-document')
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
    return () => {
      form.resetFields()
      internalDocumentStore.clearSelectedInternalDocumentOutgoing()
      selectPeopleStore.clearSelected()
      internalDocumentStore.clearAssignList()
    }
  }, [documentId])

  return (
    <DashboardLayout>
      <Helmet>
        <title>{`${title} | ${systemName} Quản lý VB nội bộ`}</title>
      </Helmet>

      <PageTitle
        location={props.location}
        title={title}
        showTitle={true}
        color={commonStore.appTheme.solidColor}>
        <HeadingButtonWrapper>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.edit__OUTGOING) && (
              <Button
                style={{ borderRadius: 8 }}
                icon={<EditOutlined />}
                onClick={() =>
                  history.push(`/internal-document/outgoing-document/${documentId}`)
                }>
                Chỉnh sửa văn bản
              </Button>
            )}
            {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.xuly__OUTGOING) && (
              <Button
                style={{ borderRadius: 8 }}
                icon={<FormOutlined />}
                onClick={() => setIsVisiblePopupHandleDocument(true)}>
                Xử lý văn bản
              </Button>
            )}
            <Dropdown overlay={menuHandleDocument} trigger={['click']}>
              <Button style={{ borderRadius: 8, padding: '4px 8px' }} icon={<MoreOutlined />} />
            </Dropdown>
          </div>
        </HeadingButtonWrapper>
      </PageTitle>
      <style>{`
        .custom-detail-tabs .ant-tabs-nav::before {
          border-bottom: 1px solid #e8e8e8;
        }
        .custom-detail-tabs .ant-tabs-tab {
          padding: 12px 16px;
        }
      `}</style>
      <DocumentContentWrapper>
        <BlockLeft>{renderAttachment}</BlockLeft>
        <BlockRight>
          <div style={{ backgroundColor: '#f5f7fa', padding: '24px', borderRadius: 16, marginBottom: 16 }}>
            <Tabs defaultActiveKey="info">
              <Tabs.TabPane tab="Thông tin chung" key="info">
                <div style={{ marginTop: 8 }}>
                  <div style={{ display: 'flex', padding: '12px 0', borderBottom: '1px solid #ebebeb' }}>
                    <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Số hiệu:</div>
                    <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>{renderInfoText(document_number)}</div>
                  </div>
                  
                  <div style={{ display: 'flex', padding: '12px 0', borderBottom: '1px solid #ebebeb' }}>
                    <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Ngày ban hành:</div>
                    <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                      {date_issued ? <><CalendarOutlined style={{ marginRight: 6, color: '#1890ff' }} />{moment(date_issued).format(DATE_TIME_FORMAT_DEFAULT)}</> : <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không rõ ngày ban hành.</span>}
                    </div>
                  </div>

                  <div style={{ display: 'flex', padding: '12px 0', borderBottom: '1px solid #ebebeb' }}>
                    <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Người ký:</div>
                    <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                      {signer ? signer : <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có người ký.</span>}
                    </div>
                  </div>

                  <div style={{ display: 'flex', padding: '12px 0', borderBottom: '1px solid #ebebeb' }}>
                    <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>CQ ban hành:</div>
                    <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                      {WordBreak(renderAuthorityIssuedList(authority_issued_id, agency_issued))}
                    </div>
                  </div>

                  <div style={{ display: 'flex', padding: '12px 0', borderBottom: '1px solid #ebebeb' }}>
                    <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Nơi nhận:</div>
                    <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                      {receive_address ? receive_address : <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có nơi nhận.</span>}
                    </div>
                  </div>

                  {/* <div style={{ display: 'flex', padding: '12px 0', borderBottom: '1px solid #ebebeb' }}>
                    <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Người theo dõi:</div>
                    <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                      {getFollowerText() ? getFollowerText() : <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có người theo dõi.</span>}
                    </div>
                  </div> */}

                  <div style={{ display: 'flex', padding: '12px 0' }}>
                    <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Tài liệu đính kèm:</div>
                    <div style={{ flex: 1, maxHeight: 150, overflowY: 'auto', paddingRight: 4 }}>
                      {attachments && attachments.length > 0 ? (
                        attachments.map(file => (
                          <FileItem
                            key={file.id}
                            file_id={file.id}
                            file_name={file.name}
                            file_type={utils.getExtensionFile(file.name)}
                          />
                        ))
                      ) : (
                        <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có.</span>
                      )}
                    </div>
                  </div>
                </div>
            </Tabs.TabPane>

            <Tabs.TabPane tab="Liên kết" key="linked">
              <div style={{ marginTop: 8 }}>
                <div style={{ marginBottom: 20 }}>
                  <div style={{ color: '#555', fontWeight: 600, marginBottom: 10, fontSize: 14 }}>Liên kết nhiệm vụ</div>
                  <div>
                    {linkedTask && linkedTask.length > 0 ? (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <LinkedTask linkedTaskList={linkedTask} />
                      </div>
                    ) : (
                      <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có.</span>
                    )}
                  </div>
                </div>

                <div>
                  <div style={{ color: '#555', fontWeight: 600, marginBottom: 10, fontSize: 14 }}>Liên kết công việc</div>
                  <div>
                    {linkedWork && linkedWork.length > 0 ? (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <LinkedWork linkedWorkList={linkedWork} />
                      </div>
                    ) : (
                      <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có.</span>
                    )}
                  </div>
                </div>
              </div>
            </Tabs.TabPane>
          </Tabs>
          </div>
          
          <div style={{ backgroundColor: '#f5f7fa', padding: '16px 24px 24px 24px', borderRadius: 16, marginBottom: 16 }}>
            <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>Ý kiến</div>
            <div style={{ position: 'relative' }}>
              <InternalDocumentComment
                documentId={documentId}
                setIsLoadingComment={bool => setIsLoadingComment(bool)}
              />
              <SpinnerInlineComponent
                sizeSpin={'small'}
                isLoading={isLoadingComment}
              />
            </div>
          </div>

          <div style={{ backgroundColor: '#f5f7fa', padding: '16px 24px 24px 24px', borderRadius: 16, marginBottom: 16 }}>
            <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>Xử lý văn bản</div>
            <div style={{ paddingTop: 8 }}>
              <Row gutter={[16, 24]}>
                <Col span={24}>
                  <div style={{ color: '#333', fontSize: 14, fontWeight: 600, marginBottom: 8 }}>Người theo dõi:</div>
                  <div style={{ fontSize: 14 }}>
                    {followerAssignList.length !== 0 ? (
                      <div>
                        <div style={{ color: '#333', marginBottom: 6, wordBreak: 'break-word' }}>{getFollowerText()}</div>
                        <PopoverWatchTime departWithUsers={departWithUsers} userList={followerAssignList} title={'Danh sách người phối hợp/ theo dõi'} isFullViewer={true} showViewLogLabel={true} compared_date={VIEWLOG_DATE.internal_document_until} typeId={documentId} created_at={created_at} />
                      </div>
                    ) : (
                      <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có.</span>
                    )}
                  </div>
                </Col>
              </Row>
              
              <AccessControlAction aclActionType={ACL_ACTION_TYPE.phanphat__OUTGOING}>
                <div style={{ marginTop: 24 }}>
                  <Button 
                    type="primary" 
                    block 
                    style={{ borderRadius: 8, height: 40 }}
                    onClick={() => setIsVisiblePopupPhanPhatDocument(true)}
                  >
                    Phân phát
                  </Button>
                </div>
              </AccessControlAction>
            </div>
          </div>
        </BlockRight>
      </DocumentContentWrapper>
      <PopupHandleDocumentOutgoing
        isVisiblePopupHandleDocument={isVisiblePopupHandleDocument}
        handleCancelHandleDocument={() =>
          setIsVisiblePopupHandleDocument(false)
        }
        handleCloseHandleDocument={() => setIsVisiblePopupHandleDocument(false)}
      />

      <PopupPhanPhatDocument
        typeDocument={DOCUMENT_TYPE.OUTGOING}
        selectedInternalDocument={selectedInternalDocumentOutgoing}
        isVisiblePopupPhanPhatDocument={isVisiblePopupPhanPhatDocument}
        handleClosePopupPhanPhatDocument={() =>
          setIsVisiblePopupPhanPhatDocument(false)
        }
      />
    </DashboardLayout>
  )
}

InternalDocumentOutgoingDocDetailPage.propTypes = {}

export default memo(
  inject(
    'commonStore',
    'internalDocumentStore',
    'loadingAnimationStore',
    'departmentStore',
    'staffStore',
    'connectedDocumentStore',
    'selectPeopleStore',
    'aclStore'
  )(observer(InternalDocumentOutgoingDocDetailPage))
)
